export default __webpack_public_path__ + "static/media/check-icon-black.d85a9e6a.svg";